import { render, staticRenderFns } from "./WageAverageDetail.vue?vue&type=template&id=5dc66c02&"
import script from "./WageAverageDetail.vue?vue&type=script&lang=js&"
export * from "./WageAverageDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports